import * as yup from "yup";
import { Max, Patterns, Validation } from "../../utils/Validation.utils";
export const CaregiverInitialValues = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: ""
};
export const CaregiverSchema = yup.object().shape({
    firstName: yup
        .string()
        .max(Max.FirstName, Validation.Max)
        .required(Validation.Required),
    lastName: yup
        .string()
        .max(Max.LastName, Validation.Max)
        .required(Validation.Required),
    email: yup.string().email(Validation.Invalid).required(Validation.Required),
    phoneNumber: yup
        .string()
        .matches(Patterns.PhoneNumber, Validation.Invalid)
        .max(Max.PhoneNumber, Validation.Max)
        .required(Validation.Required)
});
